<div
  class="navbar-container"
  [ngClass]="{
    dark: globalService.theme() === 'dark'
  }"
  [style.height.px]="globalService.navbarHeight()"
>
  <div class="flex flex-center align-center gap-1">
    <img class="logo" src="../../../assets/dark/APA_Logo.svg" alt="APA_Logo" />
    <h3>IMAX</h3>
  </div>
  <!-- @if (globalService.device() !== 'desktop') {
  <div class="flex flex-center align-center">
    <i class="theme-icon pi pi-ellipsis-v" (click)="menu.toggle($event)"></i>
    <p-tieredMenu #menu [model]="items" [popup]="true" />
  </div>
  } -->
</div>
